
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.resources-banner {
  display: grid;
  grid-template-areas:
    'middle'
    'right'
    'left';
  text-align: center;
  width: 80vw;
  margin: 0 auto;
  &__wrapper {
    width: 100vw;
    margin: 2.1rem 0;
  }
}

.banner-middle-item {
  grid-area: middle;
  display: grid;
  width: 100%;

  &__heading {
    span,
    div {
      font-size: 1.6em;
      font-weight: 600;
      line-height: 1.167;
    }
  }

  &__subheading {
    padding: 0.9rem 0 2.4rem 0;

    span,
    div {
      font-size: 1.07em;
      line-height: 1.2;
      letter-spacing: 0.05em;
    }
  }
}

.banner-left-image {
  grid-area: left;
  width: 75%;
  margin: 0 auto;
}

.banner-right-image {
  grid-area: right;
  display: none;
}

@include media-query(tablet) {
  .resources-banner__wrapper {
    margin: 0;
  }

  .banner-middle-item__heading {
    span,
    div {
      font-size: 2em;
      font-weight: 800;
      line-height: 1;
    }
  }

  .banner-middle-item__subheading {
    padding: 0.9rem 0 2.4rem 0;

    span,
    div {
      font-size: 24px;
      line-height: 1.4;
      letter-spacing: 0em;
    }
  }
}

@include media-query(desktop) {
  .resources-banner {
    grid-template-areas: none;
    grid-template-columns: [left] 1fr [middle] 50% [right] 1fr;
    align-items: flex-end;
    width: 90vw;
    margin: auto;

    &__wrapper {
      margin: 0 auto;
      padding-bottom: 60px;
    }
  }

  .banner-middle-item {
    padding: 0 20px;
    width: 90%;
    margin: 0 auto;

    &__heading,
    &__subheading {
      margin: 0 auto;
      padding-bottom: 0.6rem;
    }

    &__subheading {
      display: flex;
      align-items: flex-end;
    }
  }

  .banner-left-image,
  .banner-right-image {
    width: 100%;
  }

  .banner-right-image {
    display: block;
  }
}
`